import BreadCrumb from "../../../../components/common/breadCrumb/BreadCrumb";
import { message } from "antd";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { IAllInvoices } from "../../../../common/types/commonInterfaces";
import { selectUser } from "../../../../auth/states/userSlice";
import { useGetAllInvoiceHajjQuery } from "../../Invoice_Hajj/api/endpoints/invoicehajjEndpoints";
import {
  useDeleteInvoiceHajjMutation,
  useGetAllIPackageRateQuery,
} from "../api/endpoints/packageRateEndpoints";
import InvoiceListHeader from "../../../../components/common/Invoice/InvoiceListHeader";
import { IPermission } from "../../../../common/types/commonTypes";
type Props = {
  permission?: IPermission;
  addMRPermission: ["*"] | undefined;
};
const ViewPackageRateList = ({ permission, addMRPermission }: Props) => {
  const [columnIndex, setColumnIndex] = useState<number | null>(null);

  // constant
  const [dataSource, setDataSource] = useState<IAllInvoices[]>();
  const [count, setCount] = useState<number>(0);
  const [isTrash, setIsTrash] = useState<boolean>(false);
  const user = useSelector(selectUser);
  const [date, setDate] = useState([]);
  const [search, setSearch] = useState("");

  // LINKS
  const createLink = "/package-rate/add";
  const viewLink = "/package-rate/details";
  const editLink = "/package-rate/edit";

  // GET ALL DATA ,TRASH, DELETE AND RESTORE
  const [query, setQuery] = useState<string>("");
  const {
    data,
    isFetching,
    isLoading: isLoadingData,
    refetch: getAllPackageRate,
  } = useGetAllIPackageRateQuery(
    query +
      `&from_date=${date[0] || ""}&to_date=${date[1] || ""}&search=${search}`
  );
  const allData = data?.data;

  const [deleteInvoice, { isError, isSuccess, isLoading, error }] =
    useDeleteInvoiceHajjMutation();

  // DELETE HANDLER
  const handleOnDelete = (id: number, index: number) => {
    setColumnIndex(index);
    deleteInvoice({
      id,
      query: !isTrash ? "delete" : "restore",
      user_id: user?.user_id,
    });
  };

  useEffect(() => {
    if (isSuccess) {
      setColumnIndex(null);
      message.success(
        !isTrash
          ? "Package Rate Deleted Successfully!"
          : "Package Rate Restored Successfully!"
      );
    }
    if (isError) {
      setColumnIndex(null);
      message.error("Thare was an error");
    }
  }, [isLoading, isError]);

  useEffect(() => {
    setDataSource(allData);
    setCount(data?.count || 0);
  }, [isFetching, isTrash, allData]);

  // @refetch
  const refetch = ({ query }: { query?: string }) => {
    getAllPackageRate();
  };
  return (
    <>
      {" "}
      <BreadCrumb arrOfOption={["Invoice", "PACKAGE RATE"]} />{" "}
      <InvoiceListHeader
        InvocieModalTitle={"Package Rate"}
        data={data?.data}
        setIsTrash={setIsTrash}
        createLink={createLink}
        editLink={editLink}
        handleOnDelete={handleOnDelete}
        isTrash={isTrash}
        permission={permission}
        viewLink={viewLink}
        setDataSource={setDataSource}
        dataSource={dataSource}
        isLoading={isLoadingData || isFetching}
        deleteLoading={isLoading}
        addMRPermission={addMRPermission}
        refetch={refetch}
        setCount={setCount}
        count={count}
        setQuery={setQuery}
        setDate={setDate}
        setSearch={setSearch}
        columnIndex={columnIndex}
      />
    </>
  );
};

export default ViewPackageRateList;
